<script>
    import { fade } from 'svelte/transition';
    import FVHero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import Button from '../components/LargeImgButton.svelte'
    import Heading from '../components/Heading.svelte'
    const src = {
        pc:"img/company-fv.png",
        mb:"img/company-fv_mb.png"
    }
</script>
<svelte:head>
	<title>会社情報 | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <FVHero images={src} />
    <div class="mt"></div>
    <Centering>
        <Heading
            text={{
                main:"COMPANY",
                sub:"会社情報"
            }}
        />
    </Centering>
    <Centering>
        <div class="btn-layout">
            <Button 
                href="/company/about"
                src={{
                    pc:"img/company_btn1.png",
                    mb:"img/company_btn1_mb.png",
                }}
                text="企業方針を見る"
            />
            <Button 
            href="/company/info"
            src={{
                pc:"img/company_btn2.png",
                mb:"img/company_btn2_mb.png",
            }}
            text="会社概要を見る"
        />
        </div>
    </Centering>
</div>


<style>
    .btn-layout{
        margin-top: 145px;
        margin-bottom: 125px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .mt{
        margin-top: 70px;
    }
    @media screen and (max-width:640px){
        .btn-layout{
            width: 100%;
            flex-direction: column;
            margin: 0 auto;
            margin-top: 35px;
            margin-bottom: 125px;
            align-items: center;
        }
    }
</style>